export function jsonToCsv(jsonArray: any, arrayDelimiter = ';'): string {
  const flattenObject = (obj: any, parentKey = '', res: any = {}): any => {
    for (const key in obj) {
      console.log('this is key', key);
      const propName = parentKey ? `${parentKey}.${key}` : key;
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        flattenObject(obj[key], propName, res);
      } else if (Array.isArray(obj[key])) {
        obj[key].forEach((item, index) => {
          flattenObject(item, `${propName}[${index}]`, res);
        });
      } else {
        res[propName] = obj[key];
      }
    }
    console.log('this is res', res);
    return res;
  };

  const flatArray = jsonArray.map((item: any) => flattenObject(item));

  const columnMapping: { [key: string]: string } = {
    'transactionType': 'Transaction Type',
    'amount': 'Amount',
    'transactionReference.vendor': 'Vendor',
    'transactionReference.referenceId': 'Reference ID',
    'transactionReference.completedAt': 'Completed At',
    'applicant.displayName': 'Applicant',
    'case': 'Case',
    'id': 'ID',
    'createdAt': 'Created At',
    'caseType': 'Case Type',
    'financeReference.debitGlAccount': 'Debit Account',
    'financeReference.creditGlAccount': 'Credit Account',
  };

  const filteredColumnMapping = Object.keys(columnMapping).reduce((acc, key) => {
    if (!key.includes('__typename')) {
      acc[key] = columnMapping[key];
    }
    return acc;
  }, {} as Record<string, string>);

  const headers = Object.keys(flatArray[0])
    .filter(key => !key.includes('__typename'))
    .map(key => filteredColumnMapping[key] || key);

  const reverseMapping = headers.reduce((acc, header) => {
    acc[header] = Object.keys(filteredColumnMapping).find(key => filteredColumnMapping[key] === header) || header;
    return acc;
  }, {} as Record<string, string>);

  const csvRows = flatArray.map((row: any) => {
    return headers
      .map((header) => {
        let value = row[reverseMapping[header]];
        if (Array.isArray(value)) {
          value = value.join(arrayDelimiter);
        }
        const escaped = ('' + value).replace(/"/g, '\\"');
        return `"${escaped}"`;
      })
      .join(',');
  });

  return [headers.join(','), ...csvRows].join('\n');
}

export function downloadCsv(csvData: string, filename: string = 'data.csv'): boolean {
  try {
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (error) {
    console.error('Error downloading CSV:', error);
    return false;
  }
}
